module.exports = __webpack_public_path__ + "static/9-aa29fd9cbca2504a50e6d64ae4854b80.webp";